import type { ColumnDefinition, PresetConfiguration } from '@/components/column-configurator-modal';

// Resource Budget Column Definitions
export const RESOURCE_BUDGET_COLUMNS: ColumnDefinition[] = [
  {
    id: 'role',
    name: 'Role',
    description: 'Resource role or job title',
    category: 'Resource',
    visible: true,
    locked: true,
    order: 0,
  },
  {
    id: 'budget-hours',
    name: 'Budget (h)',
    description: 'Total budgeted hours for this role',
    category: 'Resource',
    visible: true,
    order: 1,
    align: 'right',
  },
  {
    id: 'allocated-hours',
    name: 'Allocated (h)',
    description: 'Hours assigned to team members',
    category: 'Resource',
    visible: true,
    order: 2,
    align: 'right',
  },
  {
    id: 'team-allocation',
    name: 'Team Allocation',
    description: 'Staffing status based on allocated vs budget hours',
    category: 'Status',
    visible: true,
    order: 3,
  },
  {
    id: 'actual-hours',
    name: 'Actual (h)',
    description: 'Actual hours logged to date',
    category: 'Resource',
    visible: true,
    order: 4,
    align: 'right',
  },
  {
    id: 'remaining-hours',
    name: 'Remaining (h)',
    description: 'Hours remaining in budget',
    category: 'Resource',
    visible: true,
    order: 5,
    align: 'right',
  },
  {
    id: 'percent-used',
    name: '% Used',
    description: 'Percentage of budget consumed',
    category: 'Performance',
    visible: true,
    order: 6,
    align: 'right',
  },
  {
    id: 'status',
    name: 'Status',
    description: 'Budget health status indicator',
    category: 'Status',
    visible: true,
    order: 7,
  },
  {
    id: 'variance-hours',
    name: 'Variance (h)',
    description: 'Difference between actual and budget hours',
    category: 'Performance',
    visible: false,
    order: 8,
    align: 'right',
  },
  {
    id: 'forecast-hours',
    name: 'Forecast (h)',
    description: 'Projected total hours at completion',
    category: 'Performance',
    visible: false,
    order: 9,
    align: 'right',
  },
  {
    id: 'efficiency',
    name: 'Efficiency',
    description: 'Resource efficiency rating',
    category: 'Performance',
    visible: false,
    order: 10,
    align: 'right',
  },
];

// Resource Budget Preset Configurations
export const RESOURCE_BUDGET_PRESETS: PresetConfiguration[] = [
  {
    id: 'default',
    name: 'Default View',
    columns: [
      { id: 'role', visible: true },
      { id: 'budget-hours', visible: true },
      { id: 'allocated-hours', visible: true },
      { id: 'team-allocation', visible: true },
      { id: 'actual-hours', visible: true },
      { id: 'remaining-hours', visible: true },
      { id: 'percent-used', visible: true },
      { id: 'status', visible: true },
    ],
  },
  {
    id: 'hours-focused',
    name: 'Hours Focused',
    columns: [
      { id: 'role', visible: true },
      { id: 'budget-hours', visible: true },
      { id: 'allocated-hours', visible: true },
      { id: 'team-allocation', visible: true },
      { id: 'actual-hours', visible: true },
      { id: 'remaining-hours', visible: true },
      { id: 'percent-used', visible: true },
      { id: 'variance-hours', visible: true },
      { id: 'forecast-hours', visible: true },
      { id: 'status', visible: true },
    ],
  },
  {
    id: 'performance',
    name: 'Performance View',
    columns: [
      { id: 'role', visible: true },
      { id: 'percent-used', visible: true },
      { id: 'variance-hours', visible: true },
      { id: 'efficiency', visible: true },
      { id: 'status', visible: true },
    ],
  },
  {
    id: 'compact',
    name: 'Compact View',
    columns: [
      { id: 'role', visible: true },
      { id: 'budget-hours', visible: true },
      { id: 'allocated-hours', visible: true },
      { id: 'team-allocation', visible: true },
      { id: 'actual-hours', visible: true },
      { id: 'percent-used', visible: true },
      { id: 'status', visible: true },
    ],
  },
];

// Storage key for resource budget column preferences
// Version 4: Added Team Allocation column
export const RESOURCE_BUDGET_STORAGE_KEY = 'resource-budget-column-preferences-v4';
